import { render, staticRenderFns } from "./EditAcademy.vue?vue&type=template&id=c81321d8&"
import script from "./EditAcademy.vue?vue&type=script&lang=js&"
export * from "./EditAcademy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports